import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import DashboardPageFilters from '@awp/components/dashboards/PageFilters';
import VisualContainer from '@awp/components/dashboards/GraphView/VisualContainer';
import DetailContainer from '@awp/components/dashboards/GraphView/DetailContainer';
import { fetchEetRegions } from '@stores/geographicAreaSlice';
import { Container } from 'react-bootstrap';
import { selectFullScreen } from '@awp/stores/fullScreenSlice';

const DashboardPage = () => {
  const dispatch = useDispatch();
  const fullScreen = useSelector(selectFullScreen);

  useEffect(() => {
    dispatch(fetchEetRegions());
  }, []);

  useEffect(() => {
    containerClass = !fullScreen.enabled ? 'mt-4 wrapper flex-grow-1' : 'page-card-max';
  }, [fullScreen]);

  let containerClass = !fullScreen.enabled ? 'mt-4 wrapper flex-grow-1' : 'page-card-max';

  return (
    <Container className={containerClass}>
      {!fullScreen.enabled && <DashboardPageFilters />}
      <VisualContainer id={`visual-container-id`} key={`visual-container-id-${1}`} />
      {!fullScreen.enabled && <DetailContainer />}
    </Container>
  );
};

export default DashboardPage;
